import themes from './themes';
import React from 'react';
import ThemeListItem from './theme-list-item';

class ThemeList extends React.Component {
  render(){
    return (
      <div>
        <ul className="list-group sidebar-list thin-scrollbar">
          {
            themes.map((theme, i) => {
              return <ThemeListItem theme={theme} key={i} />
            })
          }
        </ul>
      </div>
    )
  }
}

export default ThemeList;